/**
 * Consent gate for cwp/slot-demo. Replaces the poster with a sandboxed iframe
 * pointing at the provider's demo URL when the user clicks Load.
 *
 * Markup contract (see src/blocks/slot-demo/render.php):
 *   .cwp-slot-demo[data-slot-demo]
 *     .cwp-slot-demo__frame
 *       .cwp-slot-demo__poster[data-slot-demo-poster]
 *         button.cwp-slot-demo__load[data-slot-demo-load][data-demo-url="..."]
 */
export const cwpSlotDemo = {
	init() {
		document.querySelectorAll('[data-slot-demo]').forEach((root) => {
			const poster = root.querySelector('[data-slot-demo-poster]');
			const button = root.querySelector('[data-slot-demo-load]');
			const frameWrap = root.querySelector('.cwp-slot-demo__frame');

			if (!poster || !button || !frameWrap) {
				return;
			}

			button.addEventListener('click', (event) => {
				event.preventDefault();

				const url = button.dataset.demoUrl;

				if (!url) {
					return;
				}

				const iframe = document.createElement('iframe');
				iframe.src = url;
				iframe.title = button.closest('.cwp-slot-demo').querySelector('.cwp-slot-demo__title')?.textContent || 'Slot demo';
				iframe.referrerPolicy = 'strict-origin-when-cross-origin';
				iframe.allow = 'autoplay; fullscreen';
				iframe.setAttribute('allowfullscreen', '');
				iframe.loading = 'eager';

				poster.replaceWith(iframe);
			});
		});
	},
};
